import PoHistory from 'src/components/PoHistory';
import PrintVarianceDetails from './PrintVarianceDetails';

const VarianceActionButtons = () => (
  <div className="h-14 mb-2 px-2">
    <div className="h-full w-full flex justify-end items-center gap-2">
      <PoHistory title={'Variance'} />
      <PrintVarianceDetails />
    </div>
  </div>
);

export default VarianceActionButtons;
